import { Controller } from "@hotwired/stimulus"

// data-controller="capsule"
export default class extends Controller {
  static targets = ["panel", "backdrop", "openButton", "showListButton", "totalVideo"]

  connect() {
    this._onLessonLoaded = () => this.close()
    this._onKeydown = (event) => {
      if (event.key === "Escape") this.close()
    }

    this.element.addEventListener("lesson:loaded", this._onLessonLoaded)
    document.addEventListener("keydown", this._onKeydown)
    this.close()
  }

  disconnect() {
    this.element.removeEventListener("lesson:loaded", this._onLessonLoaded)
    document.removeEventListener("keydown", this._onKeydown)
    this.close()
  }

  open(event) {
    event?.preventDefault()
    if (!this.isMobile()) return

    this.panelTarget.classList.add("is-open")
    this.backdropTarget.classList.add("is-open")
    document.body.classList.add("lesson-content-list-open")

    if (this.hasOpenButtonTarget) {
      this.openButtonTarget.setAttribute("aria-expanded", "true")
    }
  }

  close(event) {
    event?.preventDefault()

    if (this.hasPanelTarget) {
      this.panelTarget.classList.remove("is-open")
    }

    if (this.hasBackdropTarget) {
      this.backdropTarget.classList.remove("is-open")
    }

    document.body.classList.remove("lesson-content-list-open")

    if (this.hasOpenButtonTarget) {
      this.openButtonTarget.setAttribute("aria-expanded", "false")
    }
  }

  toggleDesktop(event) {
    event?.preventDefault()
    if (this.isMobile()) return

    const panel = this.panelTarget
    const totalVideo = this.totalVideoTarget
    const showListButton = this.showListButtonTarget

    if (panel.classList.contains("hidden")) {
      panel.classList.remove("hidden")
      totalVideo.classList.remove("col-lg-12")
      totalVideo.classList.add("col-lg-8")
      showListButton.style.display = "none"
    } else {
      panel.classList.add("hidden")
      totalVideo.classList.remove("col-lg-8")
      totalVideo.classList.add("col-lg-12")
      showListButton.style.display = "flex"
    }
  }

  isMobile() {
    return window.matchMedia("(max-width: 991px)").matches
  }
}
